module.exports = __webpack_public_path__ + "static/media/abacaxi1.e025e297.png";